<template>
    <div class="d-flex mobile-row" style="gap: 20px;">
        <img height="48px" width="48px" :src="$image(row.imgUrl)" alt="item">
        <div class="d-flex flex-column mobile-row-inner">
            <p class="m-0 font f-s-16 f-w-700 l-h-24">
                {{ row.title }}
            </p>
            <span class="font f-s-14 f-w-400 l-h-20">{{ row.caption }}</span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        row: {
            type: Object,
            default: () => ({}),
        },
    },
};
</script>

<style lang="scss" scoped>

@media (max-width: 768px) {
    .mobile-row {
        flex-direction: column;
        align-items: center;
    }

    .mobile-row-inner{
        align-items: center;
        & span {
            text-align: center;
        }
    }
}
</style>
